import React, { useEffect, useState } from "react";
import styled from "styled-components";
import moment from "moment";
import TableTitle from "../../../component/atoms/text/table/tableTitle";
import DetailPageForm from "../../../component/atoms/layout/detail/detailPageForm";
import DetailFormTitle from "../../../component/atoms/text/detail/detailFormTitle";
import DetailFormText from "../../../component/atoms/text/detail/detailFormText";

function CommunityCommentModal({ data, setModalOpen }) {
  return (
    <ModalWrapper>
      <ModalBox>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "30px",
          }}
        >
          <TableTitle style={{ marginBottom: "0px" }}>댓글 상세</TableTitle>
          <img
            style={{
              cursor: "pointer",
            }}
            src="/assets/admin/icons/ico_popup_close.svg"
            alt=""
            onClick={() => setModalOpen(false)}
          />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            minHeight: "223px",
            overflowY: "auto",
          }}
        >
          <DetailPageForm>
            <DetailFormTitle>날짜/시간</DetailFormTitle>
            <DetailFormText>
              {moment(data?.createdAt).format("YYYY/MM/DD HH:mm:ss")}
            </DetailFormText>
          </DetailPageForm>
          <DetailPageForm>
            <DetailFormTitle>아이디</DetailFormTitle>
            <DetailFormText>{data?.member?.account}</DetailFormText>
          </DetailPageForm>
          <DetailPageForm>
            <DetailFormTitle>이름</DetailFormTitle>
            <DetailFormText>{data?.member?.name}</DetailFormText>
          </DetailPageForm>
          <DetailPageForm>
            <DetailFormTitle>닉네임</DetailFormTitle>
            <DetailFormText>{data?.member?.nickname}</DetailFormText>
          </DetailPageForm>
          <DetailPageForm style={{ alignItems: "flex-start" }}>
            <DetailFormTitle>댓글 내용</DetailFormTitle>
            <DetailFormText>{data?.content}</DetailFormText>
          </DetailPageForm>
        </div>
      </ModalBox>
    </ModalWrapper>
  );
}

export default CommunityCommentModal;

const ModalWrapper = styled.div.attrs((props) => {})`
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #00000060;
  position: fixed;
  top: 0;
  right: 0;
  z-index: 30;
`;

const ModalBox = styled.div.attrs((props) => {})`
  width: 1064px;
  min-height: 328px;
  max-height: 700px;
  overflow: auto;
  padding: 50px;
  border: 1px solid #d7dbe0;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.25);
  position: relative;

  /* 스크롤바 스타일 */
  &::-webkit-scrollbar {
    width: 17px; /* 스크롤바 너비 */
  }

  &::-webkit-scrollbar-track {
    background: #fff; /* 스크롤바 트랙 배경색 */
    border-radius: 10px; /* 스크롤바 트랙 둥근 모서리 */
  }

  &::-webkit-scrollbar-thumb {
    background: #b0b8c1; /* 스크롤바 색상 */
    border: 7px solid #fff;
    border-radius: 10px; /* 스크롤바 둥근 모서리 */
  }
`;
